
import { useState } from 'react';

interface Mentora {
  name: string;
  role: string;
  image: string;
  bio: string[];
  highlights: string[];
}

const mentoras: Mentora[] = [
  {
    name: 'Tati Marzullo',
    role: 'CEO e Fundadora',
    image: 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/dc09147ba51664f2bfe37ca4dbc7af82.jpeg',
    bio: [
      'CEO e fundadora da Agência A+, Agency A+ e Programa Salto Alto.',
      'Mais de 15 anos de experiência em comunicação e marketing.',
      'Especialista em desenvolvimento de liderança feminina.',
      'Mentora de centenas de mulheres em suas jornadas profissionais.'
    ],
    highlights: ['Liderança', 'Empreendedorismo', 'Comunicação Estratégica']
  },
  {
    name: 'Ana Carolina Hildebrandt',
    role: 'Especialista em Comunicação',
    image: 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/bff92abfcaf0f77ececa829e8d608e29.jpeg',
    bio: [
      'Especialista em comunicação corporativa e pessoal.',
      'Experiência em grandes empresas multinacionais.',
      'Focada em desenvolver a comunicação assertiva de líderes.',
      'Palestrante e facilitadora de workshops.'
    ],
    highlights: ['Comunicação', 'Oratória', 'Marca Pessoal']
  },
  {
    name: 'Juliana Costa',
    role: 'Especialista em Liderança',
    image: 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/bd5feb73d7b13f63edb4e186a30bad83.jpeg',
    bio: [
      'Especialista em desenvolvimento de liderança.',
      'Coach executiva certificada internacionalmente.',
      'Experiência em gestão de equipes de alta performance.',
      'Mentora de líderes em transição de carreira.'
    ],
    highlights: ['Liderança', 'Coaching', 'Gestão de Equipes']
  },
  {
    name: 'Maria Gabriela Montero',
    role: 'Especialista em Desenvolvimento',
    image: 'https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/023dcbd13fe9a034ee64cde852079951.jpeg',
    bio: [
      'Especialista em desenvolvimento pessoal e profissional.',
      'Formação em psicologia organizacional.',
      'Experiência em programas de desenvolvimento de talentos.',
      'Facilitadora de processos de autoconhecimento.'
    ],
    highlights: ['Desenvolvimento', 'Autoconhecimento', 'Carreira']
  }
];

export default function MentorasSection() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(0);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Tati Marzullo - Destaque Principal */}
        <div className="mb-20">
          <div className="bg-gradient-to-br from-purple-900 via-purple-800 to-purple-900 rounded-3xl overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-2/5">
                <div className="aspect-[3/4] lg:aspect-auto lg:h-full">
                  <img
                    src={mentoras[0].image}
                    alt={mentoras[0].name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="lg:w-3/5 p-8 lg:p-12 flex flex-col justify-center">
                <span className="inline-block bg-gold-500 text-purple-900 px-4 py-1 rounded-full text-sm font-bold mb-4 self-start">
                  Fundadora
                </span>
                <h2 className="text-3xl lg:text-4xl font-bold text-white mb-2">
                  {mentoras[0].name}
                </h2>
                <p className="text-gold-400 text-lg mb-6">{mentoras[0].role}</p>
                
                <div className="space-y-4 mb-8">
                  {mentoras[0].bio.map((paragraph, idx) => (
                    <p key={idx} className="text-white/90 text-lg leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>

                <div className="flex flex-wrap gap-3">
                  {mentoras[0].highlights.map((highlight, idx) => (
                    <span
                      key={idx}
                      className="bg-white/10 text-white px-4 py-2 rounded-full text-sm font-medium"
                    >
                      {highlight}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Outras Mentoras */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center">
            Nossas Especialistas
          </h3>
          <p className="text-gray-600 text-center mb-12">
            Conheça as profissionais que vão te acompanhar nessa jornada
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {mentoras.slice(1).map((mentora, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={mentora.image}
                  alt={mentora.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">
                  {mentora.name}
                </h3>
                <p className="text-purple-600 font-medium mb-4">{mentora.role}</p>
                
                <div className="space-y-2 mb-6">
                  {mentora.bio.map((paragraph, idx) => (
                    <p key={idx} className="text-gray-600 text-sm leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>

                <div className="flex flex-wrap gap-2">
                  {mentora.highlights.map((highlight, idx) => (
                    <span
                      key={idx}
                      className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-xs font-medium"
                    >
                      {highlight}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Convidadas Especiais */}
        <div className="mt-20 text-center">
          <div className="bg-gradient-to-r from-purple-50 via-pink-50 to-purple-50 rounded-3xl p-12">
            <div className="w-16 h-16 flex items-center justify-center bg-purple-100 rounded-full mx-auto mb-6">
              <i className="ri-star-smile-line text-3xl text-purple-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              + Convidadas Especiais
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Além das nossas mentoras fixas, cada módulo conta com convidadas especiais - 
              profissionais de destaque em suas áreas que trazem experiências únicas e insights valiosos para sua formação.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
